import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WallFolderWithRelations, UpdateWallFolderDto } from 'types';

export const updateFolder = ({
  data,
  folderId,
}: {
  data: UpdateWallFolderDto;
  folderId: number;
}): Promise<WallFolderWithRelations> => {
  return axios.put(`/api/folders/${folderId}`, data);
};

type UseUpdateFolderOptions = {
  config?: MutationConfig<typeof updateFolder>;
};

export const useUpdateFolder = ({ config }: UseUpdateFolderOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousFolders) {
        queryClient.setQueryData(['folders'], context.previousFolders);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['folders']);
    },
    ...config,
    mutationFn: updateFolder,
  });
};
